import { render } from "./QuizStart.vue?vue&type=template&id=214c5dbe"
import script from "./QuizStart.vue?vue&type=script&lang=js"
export * from "./QuizStart.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/webovi/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__